<template>
  <button
    :type="type"
    :class="['btn', `btn-${variant}`, { 'btn-loading': loading }]"
    :disabled="loading || disabled"
  >
    <span v-if="loading" class="btn-spinner">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-dasharray="31.4 31.4">
          <animateTransform attributeName="transform" type="rotate" dur="0.8s" repeatCount="indefinite" values="0 12 12;360 12 12"/>
        </circle>
      </svg>
    </span>
    <span :class="{ 'btn-text-loading': loading }">
      {{ loading ? loadingText : text }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'LoadingButton',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'حفظ'
    },
    loadingText: {
      type: String,
      default: 'جاري الحفظ...'
    },
    type: {
      type: String,
      default: 'submit'
    },
    variant: {
      type: String,
      default: 'primary'
    }
  }
}
</script>

<style scoped lang="scss">
.btn-loading {
  position: relative;
  pointer-events: none;
}

.btn-spinner {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;

  svg {
    width: 16px;
    height: 16px;
  }
}

.btn-text-loading {
  opacity: 0.9;
}
</style>
